export default __webpack_public_path__ + "img/67bf6e93f4554d3df6305a7f3aed20fb.png";